import Keycloak from "keycloak-js";

const keycloakInstance = new Keycloak(`/resources/keycloak.json`);

export const storeTokens = () => {
  if (keycloakInstance?.token) {
    console.log("keycloak token ", keycloakInstance?.token);
  }
};

export const Login = (redirectUri?: string) => {
  keycloakInstance?.login({ prompt: "login", redirectUri: redirectUri });
};
export const LogOut = () => {
  keycloakInstance.logout({
    redirectUri: window.location.origin + "/health",
  });
};
export default keycloakInstance;
